import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { renderPartnerLogo, partnersContent } from './utils';

const OrganizersSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('memorial-language') || 'en';
    setCurrentLanguage(savedLanguage);

    // Listen for language changes
    const handleLanguageChange = (event) => {
      const newLanguage = event.detail?.language || 'en';
      setCurrentLanguage(newLanguage);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  // Organizers
  const organizers = [
    {
      id: 1,
      name: "ULFED",
      logo: "/assets/logos/ULFED.png",
      logoAlt: "ULFED - Uluslararası STK Federasyonu logo",
      about: {
        ar: "منبر منظمات المجتمع المدني ULFED، اتحاد غير ربحي مستقل، وكيان قانوني مسجل في “المديرية العامة لإدارة العلاقات مع المجتمع المدني” التركية، يضم مؤسسات المجتمع المدني سورية الأصل-تركية المنشأ. يعمل على تطوير انسجام مؤسسات المجتمع المدني السورية ضمن المحيط التركي. وذلك عبر تعزيز عملية التواصل، ودعم بناء القدرات، وتطوير البيئة القانونية.",
        en: "International NGO Federation - A platform that brings together civil society organizations and enhances cooperation and coordination among them to achieve sustainable development goals and serve local communities.",
        tr: "Uluslararası STK Federasyonu - Sivil toplum kuruluşlarını bir araya getiren ve sürdürülebilir kalkınma hedeflerine ulaşmak ve yerel topluluklara hizmet etmek için aralarında işbirliği ve koordinasyonu artıran bir platform."
      }
    },
    {
      id: 2,
      name: "UCSO",
      logo: "/assets/logos/ucso-logo.png",
      logoAlt: "UCSO Organizations for Development logo",
      about: {
        ar: "اتحاد منظمات المجتمع المدني للتنمية - منظمة تعمل على تعزيز دور منظمات المجتمع المدني في التنمية المستدامة وبناء قدراتها لتحقيق أثر إيجابي في المجتمعات.",
        en: "Union of Civil Society Organizations for Development - An organization working to enhance the role of civil society organizations in sustainable development and build their capacities to achieve positive impact in communities.",
        tr: "Sivil Toplum Kuruluşları Kalkınma Birliği - Sivil toplum kuruluşlarının sürdürülebilir kalkınmadaki rolünü güçlendirmek ve topluluklarda olumlu etki yaratmak için kapasitelerini geliştirmek için çalışan bir organizasyon."
      }
    },
    {
      id: 3,
      name: "GUOFSS",
      logo: "/assets/logos/guofss_logo.png",
      logoAlt: "GUOFSS logo",
      isBlack: true,
      about: {
        ar: "هيئة طلابية نقابية وطنية منتخبة ومستقلة، تهدف لتمثيل الحركة الطلابية السورية في كافة الجامعات في الداخل السوري وفي الشتات، تســتمد شرعيتها من قواعدها الطلابيــة الجامعيــة، و تمثل الطلبــة السورييـن بقضاياهم وحقوقهم أمام السلطات والرأي العام في كافة أنحاء العالم.",
        en: "General Union of Syrian Civil Society Organizations - An organization working to support and develop Syrian civil society organizations and empower them to contribute effectively to building strong and stable communities.",
        tr: "Suriye Sivil Toplum Kuruluşları Genel Birliği - Suriye sivil toplum kuruluşlarını desteklemek ve geliştirmek, güçlü ve istikrarlı topluluklar inşa etmeye etkili bir şekilde katkıda bulunmalarını sağlamak için çalışan bir organizasyon."
      }
    }
  ];

  const content = partnersContent?.[currentLanguage];

  return (
    <div id="organizers">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0 }}
        className="mb-24 lg:mb-32"
      >
        <h3 className="text-2xl md:text-3xl font-semibold text-primary text-center mb-8">
          {content?.organizersTitle}
        </h3>
        <div className="space-y-12 max-w-4xl mx-auto">
          {organizers.map((item, idx) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.15 }}
              className="flex flex-col items-center text-center"
            >
              {item.logo && item.logo !== "" ? (
                <div className="flex items-center justify-center mb-6 h-32">
                  {renderPartnerLogo(item)}
                </div>
              ) : (
                <div className="text-2xl md:text-3xl font-semibold mb-6">{item.name}</div>
              )}
              {item.about && item.about[currentLanguage] && (
                <p 
                  className="text-base md:text-lg text-gray-700 leading-relaxed max-w-3xl"
                  dir={currentLanguage === 'ar' ? 'rtl' : 'ltr'}
                >
                  {item.about[currentLanguage]}
                </p>
              )}
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default OrganizersSection;

